import(/* webpackMode: "eager", webpackExports: ["FooterWrapper"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/layout/footer-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainContent"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/layout/main-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/layout/mobile-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantFavicon"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/tenant-favicon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfirmProvider"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/hooks/use-confirm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/lib/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallClientErrorHooks"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/lib/telemetry/install-client-error-hooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantProvider"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/lib/tenant-context.tsx");
